import { getCurrentUser } from '../api/auth.js';

const currentUser = getCurrentUser();

const state = {
  currentUser,
  selectedServices: [],
  currentView: currentUser ? 'calendar' : 'auth',
  userBookings: [],
  blockedDates: [],
  preselectedDate: null
};

const listeners = new Set();

export function getState() {
  return { ...state };
}

export function setState(partialState) {
  Object.assign(state, partialState);
  const updatedState = getState();
  listeners.forEach(listener => listener(updatedState));
}

export function subscribe(listener) {
  listeners.add(listener);
  listener(getState());
  return () => listeners.delete(listener);
}

export function setUserSession(user) {
  setState({ currentUser: user, currentView: user ? 'calendar' : 'auth' });
}

export function clearUserSession() {
  setState({ 
    currentUser: null, 
    selectedServices: [], 
    userBookings: [], 
    currentView: 'auth',
    preselectedDate: null
  });
}

export function setView(view) {
  if (!state.currentUser && view !== 'auth') {
    setState({ currentView: 'auth' });
    return;
  }
  setState({ currentView: view });
}

export function setPreselectedDate(dateStr) {
  setState({ preselectedDate: dateStr });
}

export function clearCart() {
  setState({ selectedServices: [] });
}
